module.exports = __webpack_public_path__ + "img/pro_eight_3.813a296d.jpg";